import React from 'react'
import { useEntryLayerContext } from '../../layers/entry'
import { useTokenLayerContext } from '../../layers/token'
import { useProductLayerContext } from '../../layers/product'
import { useDashboardLayerContext } from '../../layers/dashboard'
import { useMessageLayerContext } from '../../layers/messages/provider'
import { encode, buildConfig } from '../../layers/widget/utils'
import { useStyleLayerContext } from '../../layers/style'

const Widget = () => {
  const {
    style,
    previewConfig,
    productOverride,
    variant,
    onOptIn,
    externalBusinessId
  } = useEntryLayerContext()
  const { token } = useTokenLayerContext()
  const { widgetURL, productSlug, productName } = useProductLayerContext()
  const { widgetState, widgetKey } = useDashboardLayerContext()
  const { widgetRef } = useMessageLayerContext()
  const { border_color, border_radius } = useStyleLayerContext()

  const url =
    `${widgetURL}?` +
    `token=${token}&` +
    `config=${encode(buildConfig(style))}&` +
    `${previewConfig ? `preview=true&` : ''}` +
    `host=${window.location.origin}&` +
    `origin=${encode(window.location.origin)}&` +
    `product=${productOverride}&` +
    `hasOptIn=${typeof onOptIn === 'function' ? 'true' : 'false'}&` +
    `externalBusinessId=${externalBusinessId || ''}&` +
    `state=${widgetState ? encode(widgetState) : ''}`

  return (
    <iframe
      src={url}
      ref={widgetRef}
      id={`${productSlug}-widget`}
      title={`${productName} Widget`}
      style={{
        width: '100%',
        height: '100%',
        border: variant !== 'button' ? `1px solid ${border_color}` : 'none',
        borderRadius: border_radius,
        boxSizing: 'border-box'
      }}
      key={widgetKey}
    />
  )
}

export default Widget
